// extracted by mini-css-extract-plugin
export default {"profile":"history_entry_profile-module___profile___d7c75d12","profileDetails":"history_entry_profile-module___profileDetails___f5efe0aa"};